import { Transition, Dialog } from '@headlessui/react'
import React, { Fragment, ReactElement, useEffect, useState } from 'react'
export interface GenericDialogProps {
    prompt_message: string | ReactElement
    onCloseModal(): void
    button_position?: 'right' | 'left' | 'center'
}
const GenericDialog: React.FC<GenericDialogProps> = ({
    onCloseModal,
    prompt_message,
    children,
    button_position = 'center',
}) => {
    let [message, setMessage] = useState<ReactElement | string>(
        prompt_message
    )

    function closeModal() {
        setMessage('')
        onCloseModal()
    }

    useEffect(() => {
        if (prompt_message) setMessage(prompt_message)
    }, [prompt_message])
    return (
        <Transition
            appear
            show={!!(message || prompt_message)}
            as="div"
            enter="transition-opacity duration-75"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity duration-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-10"
        >
            <Dialog
                as="div"
                className="absolute inset-0 z-[500] overflow-y-auto"
                onClose={closeModal}
            >
                <div className="min-h-screen px-4 text-center">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 backdrop-filter backdrop-brightness-50" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span
                        className="inline-block h-screen align-middle"
                        aria-hidden="true"
                    >
                        &#8203;
                    </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                            <div className="mt-2">
                                <div
                                    className="text-sm text-gray-500"
                                    style={{ minHeight: '2rem' }}
                                >
                                    {message}
                                </div>
                            </div>

                            <div
                                className="mt-4 flex justify-around"
                                style={{ textAlign: button_position }}
                            >
                                <a
                                    type="button"
                                    className="mr-2 w-1/2 inline-flex justify-center px-4 py-2 text-sm  text-blue-900 bg-blue-100 border border-transparent rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500 font-semibold"
                                    href="http://help.aot.plus"
                                    target={'_blank'}
                                    rel="noreferrer"
                                >
                                    Visit Help Center
                                </a>
                                <button
                                    className=" w-1/2 inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-primary border border-transparent rounded-md  focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                                    onClick={closeModal}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    )
}

export default GenericDialog
